import baseInitialize from './base';
import sizeGuide from 'components/productDetail/sizeGuide';

baseInitialize();
sizeGuide.initialize();
